import {Routes} from '@angular/router';
import {DashboardPage} from './pages/dashboard-page/dashboard-page';
import {AuthGuard} from '@auth0/auth0-angular';

export const routes: Routes = [
  {
    path: '',
    component: DashboardPage,
    canActivate: [AuthGuard],
    data: { authGuardRedirect: { path: '/login' } }
  }
];
